import type { IQueueEvent } from "../../types";

const hasPitchData = (event: IQueueEvent) => event.pitch_data !== null;
const hasHitData = (event: IQueueEvent) => event.hit_data !== null;
const defaultFilter = (_event: IQueueEvent) => true;

type Filter = (_event: IQueueEvent) => boolean;
export type FilterKey = "has_pitch_data" | "has_hit_data" | "all";

export const filters: Record<FilterKey, Filter> = {
  has_pitch_data: hasPitchData,
  has_hit_data: hasHitData,
  all: defaultFilter,
};
